import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/down-arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-7dde2b2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "duty" }
const _hoisted_2 = { class: "dutycontainer" }
const _hoisted_3 = { class: "filterbox" }
const _hoisted_4 = { class: "filter-label" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "down-arrow",
  src: _imports_0
}, null, -1))
const _hoisted_6 = { class: "filter-label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "down-arrow",
  src: _imports_0
}, null, -1))
const _hoisted_8 = { class: "filter-label" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "down-arrow",
  src: _imports_0
}, null, -1))
const _hoisted_10 = { class: "showdata" }
const _hoisted_11 = { class: "ringbox" }
const _hoisted_12 = { class: "ringbox-show" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "出勤人数", -1))
const _hoisted_14 = { class: "ringbox-date" }
const _hoisted_15 = { class: "griddata" }
const _hoisted_16 = { class: "grid-n" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-t" }, "在场人数", -1))
const _hoisted_18 = { class: "grid-n" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-t" }, "工地全体人数", -1))
const _hoisted_20 = { class: "grid-n" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-t" }, "制定考勤人员出勤", -1))
const _hoisted_22 = { class: "grid-n" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-t" }, "工人出勤人数", -1))
const _hoisted_24 = { class: "week-duty" }
const _hoisted_25 = { class: "search" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("搜索")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_echart_comp = _resolveComponent("echart-comp")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!
  const _component_page_block_comp = _resolveComponent("page-block-comp")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_duty_card = _resolveComponent("duty-card")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "filter-option",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fSelectTime('year')))
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currnetYear) + "年", 1),
          _hoisted_5
        ]),
        _createElementVNode("div", {
          class: "filter-option",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fSelectTime('month')))
        }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.currnetMonth) + "月", 1),
          _hoisted_7
        ]),
        _createElementVNode("div", {
          class: "filter-option",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fSelectTime('day')))
        }, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.currnetDay) + "日", 1),
          _hoisted_9
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_echart_comp, { ref: "annularchart" }, null, 512),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.todaycheckin.checkInCount), 1),
              _createTextVNode("/" + _toDisplayString(_ctx.todaycheckin.userCount), 1)
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.computedtoptimetoday), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_van_grid, { "column-num": 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_van_grid_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.countOnSite), 1),
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_component_van_grid_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.todaycheckin.userCount), 1),
                  _hoisted_19
                ]),
                _: 1
              }),
              _createVNode(_component_van_grid_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.todaycheckin.specialCount), 1),
                  _hoisted_21
                ]),
                _: 1
              }),
              _createVNode(_component_van_grid_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.todaycheckin.workerCount), 1),
                  _hoisted_23
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_page_block_comp, { title: "周出勤率" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_echart_comp, { ref: "dutylinechart" }, null, 512)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_page_block_comp, { title: "当日出勤记录" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_van_search, {
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value) = $event)),
              placeholder: "请输入员工姓名"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_button, {
              type: "default",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filterUsername(_ctx.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_van_pull_refresh, {
            modelValue: _ctx.refreshing,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.refreshing) = $event)),
            onRefresh: _ctx.onRefresh
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_list, {
                loading: _ctx.loading,
                "onUpdate:loading": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.loading) = $event)),
                finished: _ctx.finished,
                "finished-text": "没有更多了",
                onLoad: _ctx.onLoad
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkinlist, (item, index) => {
                    return (_openBlock(), _createBlock(_component_duty_card, {
                      key: index,
                      "person-info": item
                    }, null, 8, ["person-info"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["loading", "finished", "onLoad"])
            ]),
            _: 1
          }, 8, ["modelValue", "onRefresh"])
        ]),
        _: 1
      }),
      _createVNode(_component_van_popup, {
        show: _ctx.popupShow,
        "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.popupShow) = $event)),
        position: "bottom",
        round: ""
      }, {
        default: _withCtx(() => [
          (_ctx.isShow === 'year')
            ? (_openBlock(), _createBlock(_component_van_datetime_picker, {
                key: 0,
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.date) = $event)),
                type: "date",
                title: "选择年",
                "columns-order": ['month', 'year', 'day'],
                formatter: _ctx.yearFormatter,
                onConfirm: _cache[9] || (_cache[9] = 
            (value) => {
              _ctx.fChangeTime(value, 'year');
            }
          ),
                onCancel: _ctx.fCancel
              }, null, 8, ["modelValue", "formatter", "onCancel"]))
            : _createCommentVNode("", true),
          (_ctx.isShow === 'month')
            ? (_openBlock(), _createBlock(_component_van_datetime_picker, {
                key: 1,
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.date) = $event)),
                type: "date",
                title: "选择月",
                "columns-order": ['year', 'month', 'day'],
                formatter: _ctx.monthFormatter,
                onConfirm: _cache[11] || (_cache[11] = 
            (value) => {
              _ctx.fChangeTime(value, 'month');
            }
          ),
                onCancel: _ctx.fCancel
              }, null, 8, ["modelValue", "formatter", "onCancel"]))
            : _createCommentVNode("", true),
          (_ctx.isShow === 'day')
            ? (_openBlock(), _createBlock(_component_van_datetime_picker, {
                key: 2,
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.date) = $event)),
                type: "date",
                title: "选择日",
                "columns-order": ['month', 'day', 'year'],
                formatter: _ctx.dayFormatter,
                onConfirm: _cache[13] || (_cache[13] = 
            (value) => {
              _ctx.fChangeTime(value, 'day');
            }
          ),
                onCancel: _ctx.fCancel
              }, null, 8, ["modelValue", "formatter", "onCancel"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ]))
}